import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowBoxLeft"><Path d="M9.5 12L20 12M16 16.5L20.5 12L16 7.5M11.5 20.5H3.5L3.5 3.5L11.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowBoxLeft;
